<template>
    <div :class="{ 'full-height': fullHeight }" style="height: 100%; width: 100%;">
        <LMap
            v-if="plan && mapCenter && imageLoaded"
            :style="
                fullHeight ? 'height: calc(100vh - 64px);width: 100%' : 'height: 100%;width: 100%'
            "
            :zoom="baseZoom"
            :min-zoom="2"
            :center="mapCenter"
            :crs="crs"
            @update:center="centerUpdated"
            :max-bounds="bounds"
        >
            <LMarker
                :draggable="editMarker"
                :lat-lng="markerLocation"
                v-if="markerLocation && traps.length <= 0"
                @update:latLng="updateMarkerLocation"
            ></LMarker>
            <LMarker
                v-for="trap in traps"
                :key="trap._id"
                :lat-lng="trap.planLocation"
                :icon="getIcon(trap)"
            >
                <LPopup>
                    <TrapPopup :trap="trap" />
                </LPopup>
            </LMarker>

            <LImageOverlay :url="plan.image.large.url" :bounds="bounds" />
        </LMap>
        <v-layout
            v-else
            justify-center
            align-center
            style="height: 200px; width: 100%; margin-top: 50px;"
        >
            <v-progress-circular :size="80" color="primary" indeterminate></v-progress-circular>
        </v-layout>
    </div>
</template>
<script>
import { LMap, LPopup, LIcon, LMarker, LImageOverlay } from "vue2-leaflet"
import TrapPopup from "@/components/TrapPopup"
export default {
    props: {
        plan: { type: Object, required: true },
        traps: { type: Array, required: false, default: () => [] },
        zoom: { type: Number, required: false, default: null },
        fullHeight: { type: Boolean, required: false },
        editMarker: { type: Boolean, required: false, default: false },
        value: { type: Array | Object, default: () => null },
    },
    components: {
        LMap,
        LImageOverlay,
        LMarker,
        LPopup,
        LIcon,
        TrapPopup,
    },
    data() {
        return {
            crs: L.CRS.Simple,
            baseZoom: 4,
            imageLoaded: false,
            markerLocation: null,
            mapCenter: null,
            icon: {
                noStatus: L.icon({
                    iconUrl: require("../assets/marker/no_status.svg"),
                    iconSize: [30, 30],
                    iconAnchor: [16, 16],
                }),
                armed: L.icon({
                    iconUrl: require("../assets/marker/armed.svg"),
                    iconSize: [30, 30],
                    iconAnchor: [16, 16],
                }),
                allTriggered: L.icon({
                    iconUrl: require("../assets/marker/all_triggered.svg"),
                    iconSize: [30, 30],
                    iconAnchor: [16, 16],
                }),
                halfTriggered: L.icon({
                    iconUrl: require("../assets/marker/half_triggered.svg"),
                    iconSize: [30, 30],
                    iconAnchor: [16, 16],
                }),
            },
        }
    },
    methods: {
        getIcon(trap) {
            if (!trap.status) {
                return this.icon.noStatus
            }
            if (trap.status.right && trap.status.left) {
                return this.icon.armed
            } else if (!trap.status.right && !trap.status.left) {
                return this.icon.allTriggered
            } else if (!trap.status.right || !trap.status.left) {
                return this.icon.halfTriggered
            }
        },
        centerUpdated(center) {
            this.center = center
        },

        updateMarkerLocation(location) {
            this.$emit("input", location)
        },
    },
    mounted() {
        const image = new Image()
        image.src = this.plan.image.large.url
        image.onload = () => {
            setTimeout(() => {
                this.imageLoaded = true
            }, 100)
        }

        if (!this.value) {
            this.$emit("input", { lat: 50, lng: 50 })
            this.markerLocation = { lat: 50, lng: 50 }
            this.mapCenter = { lat: 50, lng: 50 }
        } else {
            this.markerLocation = this.value
            this.mapCenter = this.value
        }
        if (window.innerWidth < 900) {
            this.baseZoom = 3
        }
        if (window.innerWidth < 600) {
            this.baseZoom = 2
        }
        if (this.zoom) {
            this.baseZoom = this.zoom
        }
    },
    computed: {
        bounds() {
            const maxHeight = 90
            const maxWidth = 180
            const bounds = [
                [0, 0],
                [0, 0],
            ]
            if (!this.plan) {
                return
            }
            if (maxHeight <= this.plan.image.large.height) {
                let ratio = maxHeight / this.plan.image.large.height
                let width = this.plan.image.large.width * ratio
                let height = maxHeight
                if (maxWidth <= width) {
                    ratio = maxWidth / width
                    height = height * ratio
                }
                bounds[0][0] = height
                bounds[1][1] = width
            }
            return bounds
        },
    },
    watch: {
        value(value) {
            if (!value) {
                this.$emit("input", { lat: 50, lng: 50 })
            }
            this.markerLocation = value || { lat: 50, lng: 50 }
        },
    },
}
</script>
<style lang="scss">
.leaflet-container {
    z-index: 0;
    width: 100%;
    height: 100%;
    .full-height & {
        height: calc(100vh - 64px) !important;
        @media only screen and (max-width: 900px) {
            height: calc(100vh - 54px) !important;
        }
    }
}
</style>
